import { NamedType } from "src/app/core.models/named-type";
import { getFieldsFromInstance } from "src/app/core.utilidades/graphql-utils";

/**
 * Modelo simplificado: solo campos de la fórmula del Excel "Cálculo de prima".
 *
 * Fórmulas (fuente de verdad):
 *   Prima Neta  = Capital × Tasa / 1000
 *   Consorcio   = MAX(capital_fallecimiento_total, capital_incapacidad_total) × 0.000003
 *   CLEA        = Prima Neta × 0.0015
 *   IPS         = Prima Neta × 0.08
 *   Prima Total = Prima Neta + Consorcio + CLEA + IPS
 */
export class CalculosPoliza implements NamedType {
    // evita perder el nombre de clase cuando ivy realiza las optimizaciones de produccion
    _className: string = 'CalculosPoliza';

    id?: number;

    // === Consorcio, CLEA, IPS (fórmulas del Excel) ===
    consorcio: number;
    clea: number;
    ips: number;

    // === Prima Neta por garantía ===
    pnFallecimiento: number;
    pnFallecimientoAccidente: number;
    pnIpa: number;
    pnTotal: number;

    // === Sobreprima por garantía ===
    sobreprimaFallecimiento: number;
    sobreprimaIpa: number;

    // === Prima total y recibos ===
    pt: number;
    primerRecibo: number;
    restoRecibo: number;

    // === Otros ===
    edadActuarial: number;
    // Factor de descuento (1 − Σ descuentos vigentes). 1 = sin descuento: se inicializa
    // para que getFieldsFromInstance lo incluya en la query GraphQL y el backend reciba
    // el mismo valor con el que calcula (auditable en BBDD y en la respuesta).
    factorDescuento: number;

    constructor() {
        this.consorcio = 0;
        this.clea = 0;
        this.ips = 0;

        this.pnFallecimiento = 0;
        this.pnFallecimientoAccidente = 0;
        this.pnIpa = 0;
        this.pnTotal = 0;

        this.sobreprimaFallecimiento = 0;
        this.sobreprimaIpa = 0;

        this.pt = 0;
        this.primerRecibo = 0;
        this.restoRecibo = 0;

        this.edadActuarial = 0;
        this.factorDescuento = 1;
    }

    public static getFields = () => {
        return getFieldsFromInstance(new CalculosPoliza());
    };
}
